module.exports = __webpack_public_path__ + "static/img/barra_4.fbf9a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_4.png
// module id = SdWb
// module chunks = 1